import React from 'react';
import { FormikProps } from 'formik';
import { FormikTextInput } from 'src/common/form/formik/text-input';
import { FormikTextarea } from 'src/common/form/formik/textarea';
import { JourneyFormik, JourneyForm } from 'src/common/JourneyFormik';
import { ToggleButton } from '../../components/dashboard/create-journey-modal';
import { NativeFormElement } from '../store';
import { AutoSubmitForm } from '../auto-submit-form';

type NativeFormInputFormProps<T> = {
  onSubmit: (values: Partial<T>) => void;
} & T;

export const NativeFormConfigInputForm = <T extends NativeFormElement>({
  onSubmit,
  ...props
}: NativeFormInputFormProps<T>) => {
  const formikParams = {
    initialValues: props,
    onSubmit,
    validateOnChange: true,
  };

  return (
    <JourneyFormik {...formikParams}>
      {({ setFieldValue }: FormikProps<Record<string, string | boolean>>) => (
        <JourneyForm className='flex flex-col gap-4 shrink-0'>
          <AutoSubmitForm />
          <FormikTextInput
            id='label'
            isNeue
            name='label'
            required
            type='text'
            label='Label'
            labelClassName='text-bedrock-p-strong text-neue-journey-fg'
          />
          <FormikTextarea
            id='description'
            name='description'
            inputClasses='h-24 bg-neue-journey-bg-90 !text-neue-journey-fg'
            label='Description'
            labelClassName='block text-bedrock-p-strong text-neue-journey-fg'
            hideOptional
          />
          <div className='flex flex-col gap-2'>
            <span className='text-neue-journey-medium-strong'>Required</span>
            <div className='flex gap-2'>
              <ToggleButton
                selected={props.required}
                label={<span>Yes</span>}
                onClick={() => {
                  setFieldValue('required', true);
                }}
              />
              <ToggleButton
                selected={!props.required}
                label={<span>No</span>}
                onClick={() => {
                  setFieldValue('required', false);
                }}
              />
            </div>
          </div>
        </JourneyForm>
      )}
    </JourneyFormik>
  );
};
